import { Menu } from "./svg/Menu";
import { Logo } from "./svg/Logo";
import { Info } from "./svg/Info";
import { Replay } from "./svg/Replay";
import { StepBack } from "./svg/StepBack";
import { Play } from "./svg/Play";
import { StepForward } from "./svg/StepForward";
import { Reset } from "./svg/Reset";
import { Pause } from "./svg/Pause";

export const config = {
  header: {
    logo: <Logo />,
    title: "SIMULATOR",
    menu: <Menu />
  },
  scenario: {
    title: "SCENARIO",
    subTitle: "ORDERS PLACED",
    buyColumnTitle: "BUY",
    sellColumnTitle: "SELL"
  },
  priceChart: {
    title: "PRICE CHART",
    lastSale: "Last Sale",
    change: "Change",
    volume: "Volume",
    replay: <Replay />,
    stepBack: <StepBack />,
    play: <Play />,
    pause: <Pause />,
    stepForward: <StepForward />,
    reset: <Reset />
  },
  prioritization: {
    title: "PRIORITIZATION",
    buyColumnTitle: "BUY",
    sellColumnTitle: "SELL"
  },
  streams: {
    title: "STREAMS",
    learn: "LEARN",
    blur: "BLUR",
    nbbo: "NBBO",
    sip: "SIP",
    match: "MATCH",
    rate: "RATE",
    average: "AVG PRICE",
    executedQty: "EXECUTED QTY",
    info: <Info />
  },
  orders: {
    placeholder: "Create orders in the scenario section to edit them here",
    infinity: "∞",
    notPresented: "MID ONLY"
  }
};
